import React from 'react';
import { DotLoader } from 'react-spinners';

const Loader = () => {
    return (
        <>
            <div className='loader_div'>
                <DotLoader size={80} color='var(--green)' />
            </div>
        </>
    )
};

export default Loader;
